// กลุ่มงาน + คู่มือทำรายการทีละขั้นตอนของสถานศึกษา (หน้า /college/home_menu)
// แหล่งข้อมูลเดียวของ CollegeWorkGroups.vue (เมนูแบ่งกลุ่มงาน), CollegeNotificationCenter.vue (ศูนย์แจ้งเตือน)
// และ CollegeTaskGuide.vue (คู่มือ) — เมื่อกระบวนงานเปลี่ยน แก้ที่ไฟล์นี้ไฟล์เดียว
//
// GROUPS[key]                 key ต้องตรงกับ group ของภารกิจใน HRvec_api/college_notification_center.php
//   title, icon, desc, anchor  anchor = id ของการ์ดในหน้า (คงชื่อเดิมไว้ให้ลิงก์ #... เดิมยังใช้ได้)
//   video                     รหัสคลิป YouTube แนะนำการใช้งาน (ถ้ามี)
//   flow[]                    ลำดับภารกิจตามรอบปี (key ของ TASK_GUIDES) — ใช้แสดง "ขั้นตอนการทำงานของกลุ่มงาน"
//   menus[]                   { text, icon, to, hint }
//
// TASK_GUIDES[taskKey]        key ต้องตรงกับ $TASKS ใน college_notification_center.php
//   purpose                   ทำไปเพื่ออะไร
//   doneWhen                  เงื่อนไขที่ระบบถือว่า "ทำรายการแล้ว"
//   steps[]                   { actor, title, detail, to?, tip? }
//                             actor: staff (เจ้าหน้าที่งานบุคลากร) | director (ผู้อำนวยการ)
//                                    | board (คณะกรรมการสถานศึกษา) | central (ส่วนกลาง) | system (ระบบ)
//   cautions[]                ข้อควรระวัง/ข้อผิดพลาดที่พบบ่อย

export const ACTORS = {
  staff: { label: "เจ้าหน้าที่งานบุคลากร", color: "teal", icon: "mdi-account-edit" },
  director: { label: "ผู้อำนวยการ", color: "indigo", icon: "mdi-account-tie" },
  board: { label: "คณะกรรมการสถานศึกษา", color: "deep-purple", icon: "mdi-account-group" },
  central: { label: "ส่วนกลาง", color: "blue-grey", icon: "mdi-shield-account" },
  system: { label: "ระบบ", color: "grey darken-1", icon: "mdi-cog" }
};

// ขั้นตอนท้ายที่ใช้ซ้ำในหลายภารกิจ
const SIGN_AND_ATTACH = [
  {
    actor: "director",
    title: "พิมพ์แบบรายงานเสนอผู้อำนวยการลงนาม",
    detail: "ใช้ปุ่มพิมพ์ในหน้าเดียวกัน ตรวจข้อมูลบนกระดาษอีกครั้งก่อนลงนาม"
  },
  {
    actor: "staff",
    title: "สแกนเป็น PDF แล้วแนบไฟล์ในระบบ",
    detail: "เมื่อแนบไฟล์สำเร็จ สถานะในศูนย์แจ้งเตือนจะเปลี่ยนเป็น “ทำรายการแล้ว” อัตโนมัติ",
    tip: "แนบไฟล์ได้เฉพาะช่วงที่ส่วนกลางเปิดให้แนบไฟล์"
  }
];

const CANCEL_NOTE =
  "หากยืนยันหรือแนบไฟล์ผิด ให้กด “ขอยกเลิก” ในหน้าเดิม แล้วรอส่วนกลางอนุมัติ — ระหว่างรอ สถานะจะเป็น “กำลังดำเนินการ”";

export const TASK_GUIDES = {
  // ---------------------------------------------------------------- ข้อมูลบุคลากร
  personnel_update: {
    title: "ปรับปรุงข้อมูลบุคลากรวิทยาลัย (งานอัตรากำลัง)",
    purpose:
      "ข้อมูลบุคลากรของวิทยาลัยใช้คำนวณอัตรากำลังและกรอบตำแหน่ง ถ้าไม่ครบหรือซ้ำ ผลการคำนวณอัตรากำลังของวิทยาลัยจะผิด",
    doneWhen: "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” ในศูนย์แจ้งเตือน (ระบบตรวจความครบถ้วนเองไม่ได้)",
    steps: [
      {
        actor: "staff",
        title: "เปิดข้อมูลบุคลากร (วิทยาลัย)",
        detail: "ตรวจรายชื่อทุกประเภท: ข้าราชการ พนักงานราชการ ลูกจ้างประจำ ลูกจ้างชั่วคราว",
        to: "/college/personnel_etc"
      },
      {
        actor: "staff",
        title: "เพิ่มผู้มาใหม่ / ลบผู้ย้ายออก เกษียณ ลาออก",
        detail: "ตรวจเลขบัตรประชาชน 13 หลักและเลขตำแหน่งให้ถูกต้องทุกรายการ"
      },
      {
        actor: "staff",
        title: "แก้รายการที่ศูนย์ตรวจสอบข้อมูลผิดปกติแจ้ง",
        detail: "ดูกล่อง “ตรวจสอบข้อมูลผิดปกติ” ในหน้าเมนูหลัก แก้ให้หมด หรือกด “ตรวจสอบแล้ว ถูกต้อง” ถ้าเป็นผลบวกลวง",
        to: "/college/home_menu"
      },
      {
        actor: "staff",
        title: "ยืนยันว่าทำรายการแล้ว",
        detail: "กลับมาที่ศูนย์แจ้งเตือน กดปุ่ม “ยืนยันว่าทำรายการแล้ว” ของภารกิจนี้"
      }
    ],
    cautions: [
      "อย่าเพิ่มบุคคลเดิมซ้ำด้วยเลขบัตรใหม่ — ให้แก้รายการเดิม",
      "ผู้ที่ย้ายออกต้องลบ/ย้ายออกจากวิทยาลัยเดิม มิฉะนั้นจะถูกนับซ้ำ 2 แห่ง"
    ]
  },

  // ---------------------------------------------------------------- อัตรากำลัง
  manpower_branch: {
    title: "แจ้งสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง",
    purpose:
      "ส่วนกลางใช้สาขาวิชาที่วิทยาลัยแจ้ง ไปจัดสรรครูย้าย/ครูผู้ช่วยลงตำแหน่งว่าง ถ้าไม่แจ้ง ตำแหน่งว่างอาจไม่ได้รับการจัดสรร",
    doneWhen: "สร้างรายงานและแนบไฟล์รายงานที่ลงนามแล้ว (สถานะรายงาน “ยืนยันแล้ว”)",
    steps: [
      {
        actor: "staff",
        title: "เปิดเมนูกำหนดสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง",
        to: "/college/man_power_j"
      },
      {
        actor: "staff",
        title: "เลือกสาขาวิชาให้ครบทุกเลขที่ตำแหน่งว่าง",
        detail: "อ้างอิงความต้องการจริงของวิทยาลัยและจำนวนนักเรียนแต่ละสาขา",
        tip: "ตำแหน่งที่ไม่ต้องการครู ให้ระบุหมายเหตุตามตัวเลือกในระบบ"
      },
      {
        actor: "staff",
        title: "ตรวจความถูกต้อง แล้วกดยืนยัน/สร้างรายงาน",
        detail: "หลังยืนยันจะแก้ไขสาขาไม่ได้ — ตรวจให้ครบก่อน"
      },
      ...SIGN_AND_ATTACH
    ],
    cautions: [CANCEL_NOTE]
  },

  // ---------------------------------------------------------------- ย้ายข้าราชการครู
  teacher_period: {
    title: "ตรวจสอบข้อมูลบุคลากรก่อนเปิดยื่นย้ายครู",
    purpose:
      "ช่วงที่ครูยื่นคำร้องขอย้าย ระบบใช้ข้อมูลจากส่วนกลาง (ตำแหน่ง วิทยฐานะ วันบรรจุ สังกัด) คำนวณสิทธิ์และคะแนน ข้อมูลผิด = คะแนนผิด",
    doneWhen: "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” หลังตรวจข้อมูลครบ",
    steps: [
      {
        actor: "staff",
        title: "เปิดข้อมูลข้าราชการครูและบุคลากร (จากส่วนกลาง)",
        to: "/college/personnel_tem"
      },
      {
        actor: "staff",
        title: "ตรวจตำแหน่ง เลขที่ตำแหน่ง วิทยฐานะ วันเดือนปีบรรจุ ของทุกคน",
        detail: "ข้อมูลส่วนนี้วิทยาลัยแก้เองไม่ได้"
      },
      {
        actor: "staff",
        title: "แจ้งส่วนกลางแก้ไขรายการที่ผิด",
        detail: "ใช้ปุ่มแจ้งปรับปรุงข้อมูลในหน้าเดียวกัน ส่วนกลางจะแก้และเปลี่ยนสถานะให้"
      },
      {
        actor: "staff",
        title: "แจ้งครูที่ประสงค์ย้ายให้ยื่นคำร้องภายในกำหนด",
        detail: "หลังปิดรับคำร้อง วิทยาลัยต้องให้ความเห็นในภารกิจ “ให้ความเห็นคำร้องขอย้ายของครู”"
      },
      { actor: "staff", title: "ยืนยันว่าทำรายการแล้วในศูนย์แจ้งเตือน" }
    ],
    cautions: ["แจ้งแก้ไขข้อมูลก่อนครูยื่นคำร้อง ถ้าแก้หลังยื่น คะแนนในคำร้องเดิมอาจไม่ถูกคำนวณใหม่"]
  },

  condition_branch: {
    title: "แจ้งเงื่อนไขสาขาวิชาที่ประสงค์รับย้าย",
    purpose:
      "บอกส่วนกลางว่าวิทยาลัยต้องการรับครูย้ายเข้าสาขาวิชาใด ครูที่ย้ายเข้าจะถูกพิจารณาตามเงื่อนไขนี้",
    doneWhen: "ยืนยันเงื่อนไขและแนบไฟล์ที่ลงนามแล้ว หรือแจ้ง “ไม่ประสงค์รับย้าย”",
    steps: [
      {
        actor: "staff",
        title: "เปิดเมนูเงื่อนไขสาขาวิชา",
        to: "/college/conditions_branch"
      },
      {
        actor: "staff",
        title: "เพิ่มสาขาวิชาที่ต้องการรับย้าย",
        detail: "เพิ่มให้ได้อย่างน้อยตามจำนวนที่ระบบกำหนด พร้อมจำนวนและเงื่อนไขเฉพาะ (ถ้ามี)",
        tip: "ถ้าไม่ต้องการรับย้ายรอบนี้ ให้เลือก “ไม่ประสงค์รับย้าย” — ถือว่าทำรายการแล้วทันที"
      },
      {
        actor: "staff",
        title: "กดยืนยันส่งเงื่อนไข",
        detail: "สถานะจะเป็น “กำลังดำเนินการ 1/2” (รอแนบไฟล์)"
      },
      ...SIGN_AND_ATTACH
    ],
    cautions: [CANCEL_NOTE, "ดูประวัติเงื่อนไขรอบก่อนได้ที่เมนู “ประวัติข้อมูลเงื่อนไขสาขาวิชาเอก”"]
  },

  teacher_request: {
    title: "ให้ความเห็นคำร้องขอย้ายของครูในสถานศึกษา",
    purpose: "ผู้อำนวยการต้องให้ความเห็นทุกคำร้องที่ครูในวิทยาลัยยื่นขอย้าย ส่วนกลางใช้ประกอบการพิจารณา",
    doneWhen: "ทุกคำร้องมีความเห็น “เห็นควร” (พร้อมไฟล์แนบ) หรือ “ไม่เห็นควร”",
    steps: [
      {
        actor: "staff",
        title: "เปิดเมนูคำร้องขอย้าย (สายการสอน ย้ายออก)",
        to: "/college/transference_personnel"
      },
      {
        actor: "staff",
        title: "พิมพ์คำร้องแต่ละรายเสนอผู้อำนวยการ",
        detail: "ตรวจเหตุผลการย้ายและเอกสารประกอบให้ครบ"
      },
      {
        actor: "director",
        title: "ผู้อำนวยการให้ความเห็นและลงนาม",
        detail: "เห็นควร / ไม่เห็นควร"
      },
      {
        actor: "staff",
        title: "บันทึกความเห็นในระบบ",
        detail: "คลิกสถานะของรายการ เลือกความเห็น — กรณี “เห็นควร” ต้องแนบไฟล์คำร้องที่ลงนามแล้ว",
        tip: "ศูนย์แจ้งเตือนแสดงจำนวนที่ทำแล้ว/ทั้งหมด ให้ทำจนครบทุกคำร้อง"
      }
    ],
    cautions: ["“เห็นควร” ที่ยังไม่แนบไฟล์ ยังไม่นับว่าทำรายการแล้ว", CANCEL_NOTE]
  },

  discuss_teacher: {
    title: "พิจารณาครูที่ประสงค์ย้ายเข้าสถานศึกษา",
    purpose: "วิทยาลัยปลายทางพิจารณาว่าครูที่ขอย้ายเข้าตรงกับความต้องการ/เงื่อนไขสาขาที่แจ้งไว้หรือไม่",
    doneWhen: "ทุกรายชื่อได้รับการบันทึกผลพิจารณา (เห็นควร/ไม่เห็นควร)",
    steps: [
      {
        actor: "staff",
        title: "เปิดเมนูครูประสงค์ย้ายเข้า",
        to: "/college/transference_personnel_movein"
      },
      {
        actor: "staff",
        title: "ตรวจรายชื่อ สาขาวิชา เทียบกับเงื่อนไขที่วิทยาลัยแจ้ง",
        detail: "ระบบแสดงว่าสาขาของผู้ขอย้ายตรงกับเงื่อนไขหรือไม่"
      },
      {
        actor: "board",
        title: "เสนอที่ประชุมพิจารณา",
        detail: "ผู้อำนวยการ/คณะกรรมการพิจารณาตามแนวปฏิบัติของรอบนั้น"
      },
      {
        actor: "staff",
        title: "บันทึกผลพิจารณาและแนบเอกสาร",
        detail: "เลือกเห็นควร/ไม่เห็นควร ทีละราย แล้วแนบไฟล์มติ/ความเห็น"
      }
    ],
    cautions: ["ยกเลิกผลที่บันทึกผิดได้จากปุ่มยกเลิกในรายการ (ไฟล์เดิมจะถูกลบ)"]
  },

  reportmove_teacher: {
    title: "รับรายงานตัวครูย้าย (กรณีปกติ)",
    purpose: "ยืนยันว่าครูที่ได้รับคำสั่งย้ายมารายงานตัวที่วิทยาลัยแล้ว เพื่อให้ส่วนกลางปรับข้อมูลสังกัดและตำแหน่ง",
    doneWhen: "ทุกรายชื่อบันทึกผล “มารายงานตัว” หรือ “ไม่มารายงานตัว” แล้ว",
    steps: [
      {
        actor: "staff",
        title: "เปิดเมนูรับรายงานตัวครูย้าย",
        to: "/college/conditons_transfer_success"
      },
      {
        actor: "staff",
        title: "เมื่อครูมารายงานตัว กดรับรายงานตัว",
        detail: "ระบุวันที่รายงานตัว และแนบหลักฐาน/คำสั่ง"
      },
      {
        actor: "staff",
        title: "กรณีไม่มารายงานตัว",
        detail: "เลือก “ไม่มารายงานตัว” พร้อมเหตุผล เพื่อให้ส่วนกลางดำเนินการต่อ"
      }
    ],
    cautions: [CANCEL_NOTE, "ตรวจเลขที่ตำแหน่งที่รับย้ายให้ตรงกับอัตรากำลังของวิทยาลัย"]
  },

  // ---------------------------------------------------------------- ย้ายผู้บริหาร
  manage_filing_director: {
    title: "เปิดยื่นคำร้องขอย้าย ตำแหน่งผู้อำนวยการวิทยาลัย",
    purpose:
      "ช่วงที่ผู้อำนวยการยื่นคำร้องขอย้าย ระบบใช้ข้อมูลจากส่วนกลาง (ตำแหน่ง วันดำรงตำแหน่งบริหาร สังกัด) คำนวณสิทธิ์และคะแนน วิทยาลัยต้องช่วยตรวจข้อมูลให้ถูกต้องก่อนปิดรับคำร้อง",
    doneWhen:
      "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” หลังตรวจข้อมูล (ศูนย์แจ้งเตือนแสดงจำนวนผู้อำนวยการในวิทยาลัยที่ยื่นคำร้องแล้วประกอบ)",
    steps: [
      {
        actor: "staff",
        title: "ตรวจข้อมูลผู้อำนวยการจากส่วนกลาง",
        detail: "ตำแหน่ง เลขที่ตำแหน่ง วันที่ดำรงตำแหน่งผู้อำนวยการ และวิทยาลัยที่สังกัด",
        to: "/college/personnel_tem"
      },
      {
        actor: "staff",
        title: "แจ้งส่วนกลางแก้ไขหากข้อมูลผิด",
        detail: "ใช้ปุ่มแจ้งปรับปรุงข้อมูลในหน้าเดียวกัน — ต้องแก้ก่อนผู้อำนวยการยื่นคำร้อง"
      },
      {
        actor: "director",
        title: "ผู้อำนวยการที่ประสงค์ย้ายยื่นคำร้องในระบบด้วยบัญชีของตนเอง",
        detail: "กรณีปกติ / กรณีพิเศษ / ย้ายเพื่อพัฒนาคุณภาพ พร้อมแนบไฟล์แบบคำร้องภายในวันที่กำหนด",
        tip: "การยื่นคำร้องทำในบัญชีบุคลากร ไม่ใช่บัญชีสถานศึกษา"
      },
      {
        actor: "central",
        title: "สอจ. และส่วนกลางพิจารณาคำร้อง",
        detail: "หลังปิดรับคำร้อง วิทยาลัยปลายทางจะได้รับภารกิจ “ให้ความเห็นชอบผู้บริหารที่ประสงค์ย้ายเข้า”"
      },
      { actor: "staff", title: "ยืนยันว่าทำรายการแล้วในศูนย์แจ้งเตือน" }
    ],
    cautions: [
      "ข้อมูลวันดำรงตำแหน่งที่ผิดทำให้คุณสมบัติ/คะแนนการย้ายผิด และแก้ไขภายหลังปิดรับคำร้องได้ยาก",
      "ไฟล์แบบคำร้องแนบได้ถึงวันที่ส่วนกลางกำหนดเท่านั้น"
    ]
  },

  manage_filing_sedirector: {
    title: "เปิดยื่นคำร้องขอย้าย ตำแหน่งรองผู้อำนวยการวิทยาลัย",
    purpose:
      "ช่วงที่รองผู้อำนวยการยื่นคำร้องขอย้าย วิทยาลัยต้องแจ้งรองผู้อำนวยการทุกคน และตรวจข้อมูลที่ใช้คำนวณคะแนนให้ถูกต้องก่อนปิดรับคำร้อง",
    doneWhen:
      "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” หลังตรวจข้อมูล (ศูนย์แจ้งเตือนแสดงจำนวนรองผู้อำนวยการในวิทยาลัยที่ยื่นคำร้องแล้วประกอบ)",
    steps: [
      {
        actor: "staff",
        title: "แจ้งกำหนดการให้รองผู้อำนวยการทุกคนทราบ",
        detail: "ระบุวันเปิด-ปิดรับคำร้อง และวันสุดท้ายของการแนบไฟล์"
      },
      {
        actor: "staff",
        title: "ตรวจข้อมูลรองผู้อำนวยการจากส่วนกลาง",
        detail: "ตำแหน่ง เลขที่ตำแหน่ง วันที่ดำรงตำแหน่งรองผู้อำนวยการ",
        to: "/college/personnel_tem"
      },
      {
        actor: "staff",
        title: "แจ้งส่วนกลางแก้ไขหากข้อมูลผิด",
        detail: "ใช้ปุ่มแจ้งปรับปรุงข้อมูลในหน้าเดียวกัน"
      },
      {
        actor: "director",
        title: "รองผู้อำนวยการยื่นคำร้องในระบบด้วยบัญชีของตนเอง",
        detail: "ผู้อำนวยการพิจารณาลงนามในแบบคำร้องก่อนแนบไฟล์",
        tip: "การยื่นคำร้องทำในบัญชีบุคลากร ไม่ใช่บัญชีสถานศึกษา"
      },
      { actor: "staff", title: "ยืนยันว่าทำรายการแล้วในศูนย์แจ้งเตือน" }
    ],
    cautions: ["กำหนดการของรองผู้อำนวยการแยกจากผู้อำนวยการ — วันเปิด/ปิดอาจไม่ตรงกัน"]
  },

  discuss_director: {
    title: "ให้ความเห็นชอบผู้บริหารที่ประสงค์ย้ายเข้า",
    purpose: "คณะกรรมการสถานศึกษาให้ความเห็นชอบผู้อำนวยการ/รองผู้อำนวยการที่ขอย้ายเข้าวิทยาลัย",
    doneWhen: "ทุกรายชื่อบันทึกความเห็น (เห็นชอบ/ไม่เห็นชอบ) แล้ว",
    steps: [
      {
        actor: "staff",
        title: "เปิดเมนูผู้บริหารประสงค์ย้ายเข้า",
        to: "/college/transference_manage_location"
      },
      {
        actor: "board",
        title: "จัดประชุมคณะกรรมการสถานศึกษา",
        detail: "นำข้อมูลผู้ขอย้ายเข้าที่ประชุม บันทึกครั้งที่ประชุมและวันที่"
      },
      {
        actor: "staff",
        title: "บันทึกความเห็นในระบบ",
        detail: "เลือกความเห็น กรอกครั้งที่/วันที่ประชุม เลขที่หนังสือนำส่ง และชื่อประธานกรรมการ",
        tip: "กรณี “ไม่เห็นชอบ” ต้องระบุเหตุผล"
      },
      {
        actor: "director",
        title: "พิมพ์แบบความเห็นจากระบบ ให้ประธาน/ผู้อำนวยการลงนาม"
      },
      { actor: "staff", title: "แนบไฟล์ที่ลงนามแล้ว" }
    ],
    cautions: ["แก้ไขความเห็นได้จากปุ่มแก้ไข/ยกเลิกความเห็นในรายการ ภายในกำหนดการ"]
  },

  reportmove_director: {
    title: "รับรายงานตัวผู้บริหารย้าย",
    purpose: "ยืนยันการมารายงานตัวของผู้บริหารที่ได้รับคำสั่งย้ายมาวิทยาลัย",
    doneWhen: "ทุกรายชื่อบันทึกผลการรายงานตัวแล้ว",
    steps: [
      {
        actor: "staff",
        title: "เปิดเมนูรับรายงานตัวผู้บริหาร",
        to: "/college/conditons_transfer_success_director"
      },
      {
        actor: "staff",
        title: "บันทึก มา/ไม่มา รายงานตัว พร้อมวันที่และไฟล์หลักฐาน"
      }
    ],
    cautions: [CANCEL_NOTE]
  },

  // ---------------------------------------------------------------- คัดเลือกผู้บริหาร
  sedirector_app: {
    title: "ตรวจสอบผู้สมัครคัดเลือกรองผู้อำนวยการ (ภาค ก)",
    purpose: "วิทยาลัยต้นสังกัดตรวจคุณสมบัติและรับรองข้อมูลผู้สมัครคัดเลือกรองผู้อำนวยการ",
    doneWhen: "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” หลังตรวจผู้สมัครครบ",
    steps: [
      { actor: "staff", title: "เปิดเมนูคัดเลือกตำแหน่งรองผู้อำนวยการ", to: "/college/sedirector_app" },
      {
        actor: "staff",
        title: "ตรวจข้อมูลและเอกสารของผู้สมัครแต่ละราย",
        detail: "อายุราชการ ตำแหน่ง วินัย และไฟล์แนบของผู้สมัคร"
      },
      { actor: "director", title: "ผู้อำนวยการรับรองผล ภาค ก ตามแบบที่กำหนด" },
      { actor: "staff", title: "บันทึก/แนบไฟล์ในระบบ แล้วยืนยันว่าทำรายการแล้ว" }
    ],
    cautions: ["ไฟล์แนบที่ผิดให้ขอยกเลิกไฟล์ ส่วนกลางจะเปิดให้แนบใหม่"]
  },

  sedirector_report: {
    title: "รับรายงานตัวรองผู้อำนวยการ",
    purpose: "ยืนยันการมารายงานตัวของผู้ผ่านการคัดเลือกที่ได้รับการแต่งตั้งเป็นรองผู้อำนวยการของวิทยาลัย",
    doneWhen: "ทุกรายชื่อบันทึก “มารายงานตัว” หรือ “ไม่มารายงานตัว” แล้ว",
    steps: [
      { actor: "staff", title: "เปิดเมนูรับรายงานตัวรองผู้อำนวยการ", to: "/college/sedirector_app_report" },
      { actor: "staff", title: "บันทึกผลการรายงานตัวและแนบไฟล์หลักฐาน" }
    ],
    cautions: [CANCEL_NOTE]
  },

  director_report: {
    title: "รับรายงานตัวผู้อำนวยการสถานศึกษา (บรรจุ)",
    purpose: "ยืนยันการมารายงานตัวของผู้ได้รับการบรรจุแต่งตั้งเป็นผู้อำนวยการวิทยาลัย",
    doneWhen: "ทุกรายชื่อบันทึกผลการรายงานตัวแล้ว",
    steps: [
      { actor: "staff", title: "เปิดเมนูรับรายงานตัวผู้อำนวยการ", to: "/college/director_app_report" },
      {
        actor: "staff",
        title: "บันทึกผลการรายงานตัวและแนบไฟล์หลักฐาน",
        tip: "ระบบปิดรับเวลา 16.30 น. ของวันสิ้นสุดกำหนดการ"
      }
    ],
    cautions: []
  },

  // ---------------------------------------------------------------- ครูผู้ช่วย
  assist_receive: {
    title: "รับรายงานตัวครูผู้ช่วย",
    purpose: "ยืนยันว่าผู้ได้รับการบรรจุเป็นครูผู้ช่วยมารายงานตัวที่วิทยาลัย เป็นจุดเริ่มต้นของการประเมิน 2 ปี",
    doneWhen: "ทุกรายชื่อของรอบนี้บันทึก “มารายงานตัว” หรือ “ไม่มารายงานตัว” แล้ว",
    steps: [
      { actor: "staff", title: "เปิดเมนูรับรายงานตัวครูผู้ช่วย", to: "/college/manage_assistant_teacher" },
      {
        actor: "staff",
        title: "แก้ไขข้อมูลทีละราย เลือกสถานะการรายงานตัว",
        detail: "กรอกวันที่รายงานตัว สาขาวิชาที่สอน และแนบไฟล์หลักฐาน"
      },
      {
        actor: "staff",
        title: "ต่อด้วยการแต่งตั้งคณะกรรมการประเมิน",
        detail: "ครูผู้ช่วยที่มารายงานตัวแล้วจะไปอยู่ในภารกิจ “แต่งตั้งคณะกรรมการประเมินครูผู้ช่วย”"
      }
    ],
    cautions: [CANCEL_NOTE]
  },

  assist_committee: {
    title: "แต่งตั้งคณะกรรมการประเมินครูผู้ช่วย",
    purpose: "ครูผู้ช่วยทุกคนที่มารายงานตัวต้องมีคณะกรรมการประเมินการเตรียมความพร้อมและพัฒนาอย่างเข้ม",
    doneWhen:
      "ครูผู้ช่วยที่มารายงานตัวและบรรจุตั้งแต่ปี 2567 ทุกคนมีสถานะคณะกรรมการ “ยืนยันแล้ว” (ผู้บรรจุก่อนปี 2567 ไม่ต้องดำเนินการ และไม่นับรวม)",
    steps: [
      { actor: "staff", title: "เปิดเมนูการแต่งตั้งคณะกรรมการประเมิน", to: "/college/assistantcommitteequalified" },
      {
        actor: "staff",
        title: "เลือกครูผู้ช่วยทีละราย แล้วระบุกรรมการ",
        detail: "ผู้ทรงคุณวุฒิภายนอก / ผู้บริหาร / ครูพี่เลี้ยง ตามหลักเกณฑ์"
      },
      { actor: "director", title: "ผู้อำนวยการลงนามคำสั่งแต่งตั้ง" },
      { actor: "staff", title: "แนบไฟล์คำสั่งและยืนยัน", detail: "ภารกิจนี้จะหายไปเองเมื่อครบทุกคน" }
    ],
    cautions: ["ภารกิจนี้ไม่มีกำหนดการเปิด/ปิด แต่จะแจ้งเตือนค้างไว้จนกว่าจะแต่งตั้งครบ", CANCEL_NOTE]
  },

  assist_committee_report: {
    title: "เสนอรายชื่อผู้ทรงคุณวุฒิ (กรรมการประเมินครูผู้ช่วย)",
    purpose: "เสนอรายชื่อผู้ทรงคุณวุฒิภายนอกเพื่อให้ส่วนกลาง/สถาบันรวบรวมเป็นบัญชีกรรมการ",
    doneWhen: "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” หลังเสนอรายชื่อครบ",
    steps: [
      { actor: "staff", title: "เปิดเมนูการแต่งตั้งคณะกรรมการประเมิน", to: "/college/assistantcommitteequalified" },
      { actor: "staff", title: "บันทึกรายชื่อผู้ทรงคุณวุฒิที่เสนอ พร้อมคุณวุฒิ/ตำแหน่ง" },
      { actor: "director", title: "ผู้อำนวยการรับรองรายชื่อ" },
      { actor: "staff", title: "ยืนยันว่าทำรายการแล้วในศูนย์แจ้งเตือน" }
    ],
    cautions: []
  },

  assist_license: {
    title: "สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะครูผู้ช่วย",
    purpose: "รวบรวมข้อมูลใบอนุญาตประกอบวิชาชีพของครูผู้ช่วย ใช้ติดตามการมีใบอนุญาตตามกฎหมาย",
    doneWhen: "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” หลังบันทึกครบทุกคน",
    steps: [
      { actor: "staff", title: "เปิดเมนูสำรวจใบอนุญาตฯ", to: "/college/servey_assistant_specialized_licenses" },
      { actor: "staff", title: "บันทึกเลขที่ใบอนุญาต วันออก/วันหมดอายุ และแนบไฟล์ของครูผู้ช่วยแต่ละคน" },
      { actor: "staff", title: "ส่งข้อมูลให้ส่วนกลางตรวจ แล้วยืนยันว่าทำรายการแล้ว" }
    ],
    cautions: ["ใบอนุญาตที่หมดอายุระหว่างประเมิน ให้แนบใบใหม่ทันทีที่ได้รับ"]
  },

  // ---------------------------------------------------------------- พนักงานราชการ
  govem_condition: {
    title: "แจ้งเงื่อนไขสาขา ตำแหน่งว่างพนักงานราชการ",
    purpose: "แจ้งสาขา/คุณสมบัติที่ต้องการสำหรับตำแหน่งว่างพนักงานราชการ เพื่อใช้พิจารณาการย้าย",
    doneWhen: "สร้างรายงานและแนบไฟล์ที่ลงนามแล้ว (สถานะรายงาน “ยืนยันแล้ว”)",
    steps: [
      { actor: "staff", title: "เปิดเมนูเงื่อนไขสาขา พนักงานราชการ", to: "/college/conditions_branch_govem" },
      { actor: "staff", title: "ระบุสาขาให้ทุกตำแหน่งว่าง แล้วกดยืนยัน/สร้างรายงาน" },
      ...SIGN_AND_ATTACH
    ],
    cautions: [CANCEL_NOTE]
  },

  govem_request: {
    title: "ให้ความเห็นคำร้องขอย้ายพนักงานราชการ",
    purpose: "ผู้อำนวยการให้ความเห็นคำร้องขอย้ายของพนักงานราชการในวิทยาลัย",
    doneWhen: "ทุกคำร้องมีความเห็น “เห็นควร” (พร้อมไฟล์แนบ) หรือ “ไม่เห็นควร”",
    steps: [
      { actor: "staff", title: "เปิดเมนูคำร้องขอย้ายพนักงานราชการ", to: "/college/transference_personnel_govem" },
      { actor: "director", title: "ผู้อำนวยการพิจารณาและลงนามความเห็น" },
      {
        actor: "staff",
        title: "บันทึกความเห็นทีละคำร้อง",
        detail: "กรณี “เห็นควร” ต้องแนบไฟล์คำร้องที่ลงนามแล้ว"
      }
    ],
    cautions: [CANCEL_NOTE]
  },

  govem_reportmove: {
    title: "รับรายงานตัวพนักงานราชการ (ย้าย)",
    purpose: "ยืนยันการมารายงานตัวของพนักงานราชการที่ได้รับการย้าย และบันทึกข้อมูลสัญญาจ้างที่วิทยาลัยใหม่",
    doneWhen: "ทุกรายชื่อบันทึกผลการรายงานตัวแล้ว",
    steps: [
      { actor: "staff", title: "เปิดเมนูรับรายงานตัวพนักงานราชการ", to: "/college/conditons_transfer_success_gov" },
      { actor: "staff", title: "บันทึก มา/ไม่มา รายงานตัว พร้อมข้อมูลสัญญาจ้างและไฟล์หลักฐาน" }
    ],
    cautions: [CANCEL_NOTE]
  },

  govem_manpower: {
    title: "รายงานข้อมูลพนักงานราชการ กรอบอัตรากำลัง",
    purpose: "ส่วนกลางใช้ข้อมูลกรอบอัตรากำลังพนักงานราชการคำนวณงบประมาณค่าตอบแทนตามงวด",
    doneWhen: "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” หลังรายงานงวดปัจจุบันครบ",
    steps: [
      { actor: "staff", title: "เปิดเมนูข้อมูลพนักงานราชการ กรอบอัตรากำลัง", to: "/college/gov_em/government_employee" },
      { actor: "staff", title: "ตรวจผู้ครองตำแหน่ง เลขตำแหน่ง อัตราค่าตอบแทน ให้ตรงกับสัญญาจริง" },
      { actor: "staff", title: "ส่งรายงานของงวดที่เปิด แล้วยืนยันว่าทำรายการแล้ว" }
    ],
    cautions: ["แต่ละงวดเปิดช่วงสั้น — ตรวจสัญญาที่สิ้นสุด/ต่อสัญญาให้เรียบร้อยก่อนเปิดงวด"]
  },

  govem_salary: {
    title: "รายงานค่าตอบแทนพนักงานราชการประจำปี",
    purpose: "รายงานการคำนวณค่าตอบแทนพนักงานราชการประจำปีงบประมาณ",
    doneWhen: "สถานศึกษากด “ยืนยันว่าทำรายการแล้ว” หลังส่งรายงาน",
    steps: [
      { actor: "staff", title: "เปิดเมนูการคำนวณค่าตอบแทน", to: "/college/gov_em/cal_compensation" },
      { actor: "staff", title: "ตรวจผลการประเมินและอัตราค่าตอบแทนใหม่ของแต่ละคน" },
      { actor: "director", title: "ผู้อำนวยการลงนามรายงาน" },
      { actor: "staff", title: "ส่งรายงานในระบบ แล้วยืนยันว่าทำรายการแล้ว" }
    ],
    cautions: ["ต้องบันทึกผลการประเมินการปฏิบัติงานก่อน จึงคำนวณค่าตอบแทนได้ถูกต้อง"]
  }
};

export const GROUPS = {
  general: {
    title: "ผู้ใช้งานและข้อมูลวิทยาลัย",
    icon: "mdi-domain",
    anchor: "college",
    desc: "บัญชีผู้ใช้งานของบุคลากร และข้อมูลพื้นฐานของวิทยาลัย",
    flow: [],
    menus: [
      {
        text: "บัญชีผู้ใช้งานระบบ ข้าราชการครูและบุคลากรทางการศึกษา",
        icon: "mdi-account-key",
        to: "/college/personnel",
        hint: "รีเซ็ตรหัสผ่าน/ตรวจบัญชีของบุคลากรในวิทยาลัย"
      },
      {
        text: "ข้อมูลรายละเอียดวิทยาลัย",
        icon: "mdi-information",
        to: "/college/collegeinfo",
        hint: "ที่อยู่ ผู้ติดต่อ และข้อมูลพื้นฐานของวิทยาลัย"
      }
    ]
  },
  personnel: {
    title: "ข้อมูลงานบุคคล",
    icon: "mdi-account-details",
    anchor: "personnel",
    desc: "ข้อมูลข้าราชการครู/บุคลากร คุณวุฒิ คัดเลือกบุคลากร และรายงานการเดินทางราชการ",
    flow: ["personnel_update"],
    menus: [
      {
        text: "ข้อมูลข้าราชการครูและบุคลากรทางการศึกษา (จากส่วนกลาง)",
        icon: "mdi-account",
        to: "/college/personnel_tem",
        hint: "ดูอย่างเดียว — ถ้าผิดให้แจ้งส่วนกลางแก้ไข"
      },
      {
        text: "ข้อมูลบุคลากร (วิทยาลัย) งานอัตรากำลัง",
        icon: "mdi-account-settings",
        to: "/college/personnel_etc",
        hint: "วิทยาลัยเพิ่ม/แก้ไข/ลบเอง ใช้คำนวณอัตรากำลัง"
      },
      { text: "ข้อมูลคุณวุฒิการศึกษา", icon: "mdi-school", to: "/college/personnel_education" },
      { text: "ประสบการณ์การทำงาน", icon: "mdi-briefcase-clock", to: "/college/personnel_experience" },
      { text: "ประวัติการรับราชการ", icon: "mdi-history", to: "/college/personnel_work_history" },
      { text: "ผลงาน รางวัล", icon: "mdi-trophy", to: "/college/personnel_award" },
      { text: "ประวัติวินัย โทษ", icon: "mdi-gavel", to: "/college/personnel_discipline" },
      { text: "ใบอนุญาตประกอบวิชาชีพครู (ข้าราชการครูฯ)", icon: "mdi-card-account-details-outline", to: "/college/personnel_temporarylicence" },
      { text: "ประกาศคัดเลือก/แข่งขัน บุคลากร", icon: "mdi-bullhorn", to: "/college/temporaryemployees" },
      { text: "คัดเลือก/แข่งขัน บุคลากร", icon: "mdi-account-search", to: "/college/temporarycollegeemreg" },
      { text: "รายงานการเดินทางราชการ", icon: "mdi-car", to: "/college/tripReport" }
    ]
  },
  manpower: {
    title: "อัตรากำลัง",
    icon: "mdi-human",
    anchor: "manpower",
    desc: "กำหนดสาขาวิชาสำหรับตำแหน่งว่าง ประมวลผลอัตรากำลังของวิทยาลัย และดูรายงานผลการคำนวณ",
    flow: ["manpower_branch"],
    menus: [
      { text: "กำหนดสาขาวิชาสำหรับเลขที่ตำแหน่งว่าง", icon: "mdi-briefcase-edit", to: "/college/man_power_j" },
      { text: "ข้อมูลทั่วไป (อัตรากำลัง)", icon: "mdi-clipboard-text", to: "/college/rate_workforce_g" },
      { text: "ข้อมูลอัตรากำลังวิทยาลัย", icon: "mdi-account-multiple", to: "/college/rate_workforce" },
      { text: "ข้อมูลอัตรากำลังวิทยาลัยสรุป", icon: "mdi-chart-box", to: "/college/rate_workforce_pro" },
      {
        text: "รายงานผลการคำนวณอัตรากำลัง",
        icon: "mdi-file-chart-outline",
        to: "/college/rate_workforce_report",
        hint: "ดูผลวิเคราะห์และส่งออกข้อมูลได้ตลอดเวลา แม้ช่วงประมวลผลจะปิดอยู่"
      }
    ]
  },
  move_teach: {
    title: "ย้ายข้าราชการครู",
    icon: "mdi-swap-horizontal-bold",
    anchor: "condition",
    video: "iVZy90tWSZg",
    desc: "เงื่อนไขรับย้าย ความเห็นคำร้องย้ายออก/ย้ายเข้า รับรายงานตัว และย้ายบุคลากรอื่น ม.38 ค.(2)",
    flow: ["teacher_period", "condition_branch", "teacher_request", "discuss_teacher", "reportmove_teacher"],
    menus: [
      { text: "ข้อมูลเงื่อนไขสาขาวิชาเอก (รับย้าย)", icon: "mdi-source-branch", to: "/college/conditions_branch" },
      { text: "ประวัติข้อมูลเงื่อนไขสาขาวิชาเอก", icon: "mdi-history", to: "/college/history_conditions" },
      { text: "สายการสอน ประสงค์ย้ายออก (ให้ความเห็น)", icon: "mdi-account-arrow-right", to: "/college/transference_personnel" },
      { text: "สายการสอน ประสงค์ย้ายเข้า (พิจารณา)", icon: "mdi-account-arrow-left", to: "/college/transference_personnel_movein" },
      { text: "รับรายงานตัวครูย้าย", icon: "mdi-account-check", to: "/college/conditons_transfer_success" },
      { text: "บุคลากรอื่น ม.38 ค.(2) ประสงค์ย้ายออก", icon: "mdi-account-arrow-right-outline", to: "/college/transference_personnel_38" },
      { text: "บุคลากรอื่น ม.38 ค.(2) ประสงค์ย้ายเข้า", icon: "mdi-account-arrow-left-outline", to: "/college/transference_personnel_movein_38" }
    ]
  },
  move_manage: {
    title: "ย้ายผู้บริหาร",
    icon: "mdi-account-switch",
    anchor: "move_manage",
    desc: "ช่วงยื่นคำร้องย้าย ผอ./รอง ผอ. ให้ความเห็นชอบผู้บริหารที่ขอย้ายเข้า และรับรายงานตัวผู้บริหารย้าย",
    flow: ["manage_filing_director", "manage_filing_sedirector", "discuss_director", "reportmove_director"],
    menus: [
      { text: "ผู้บริหารวิทยาลัยอื่นประสงค์ย้ายเข้า (ให้ความเห็นชอบ)", icon: "mdi-account-arrow-left", to: "/college/transference_manage_location" },
      { text: "รับรายงานตัวผู้บริหารย้าย", icon: "mdi-account-check", to: "/college/conditons_transfer_success_director" }
    ]
  },
  sedirector: {
    title: "คัดเลือกผู้บริหาร",
    icon: "mdi-account-tie",
    anchor: "assisstant_dutyDirector",
    desc: "คัดเลือกรองผู้อำนวยการ และรับรายงานตัวรองผู้อำนวยการ/ผู้อำนวยการ",
    flow: ["sedirector_app", "sedirector_report", "director_report"],
    menus: [
      { text: "คัดเลือก ตำแหน่งรองผู้อำนวยการ", icon: "mdi-clipboard-account", to: "/college/sedirector_app" },
      { text: "รับรายงานตัว ตำแหน่งรองผู้อำนวยการ", icon: "mdi-account-star", to: "/college/sedirector_app_report" },
      { text: "รับรายงานตัว บรรจุ ตำแหน่งผู้อำนวยการสถานศึกษา", icon: "mdi-account-tie", to: "/college/director_app_report" }
    ]
  },
  assist: {
    title: "ครูผู้ช่วย",
    icon: "mdi-human-male-board",
    anchor: "assisstant",
    video: "IuTKn-M-KGY",
    desc: "รับรายงานตัว แต่งตั้งคณะกรรมการประเมิน รายงานผลการประเมิน และสำรวจใบอนุญาตฯ",
    flow: ["assist_receive", "assist_committee", "assist_committee_report", "assist_license"],
    menus: [
      { text: "รับรายงานตัวครูผู้ช่วย", icon: "mdi-account-plus", to: "/college/manage_assistant_teacher" },
      { text: "การแต่งตั้งคณะกรรมการประเมิน", icon: "mdi-account-group", to: "/college/assistantcommitteequalified" },
      { text: "รายงานผลการประเมิน", icon: "mdi-file-chart", to: "/college/assistant_teacher" },
      { text: "สำรวจใบอนุญาตประกอบวิชาชีพเฉพาะ", icon: "mdi-card-account-details", to: "/college/servey_assistant_specialized_licenses" }
    ]
  },
  govem: {
    title: "พนักงานราชการ",
    icon: "mdi-account-star",
    anchor: "gov_em",
    desc: "ข้อมูลและสัญญา กรอบอัตรากำลัง การย้าย ประเมินผล และค่าตอบแทนพนักงานราชการ",
    flow: ["govem_condition", "govem_request", "govem_reportmove", "govem_manpower", "govem_salary"],
    menus: [
      { text: "ข้อมูลพนักงานราชการ และสัญญา", icon: "mdi-file-sign", to: "/college/gov_em/personnel_govem" },
      { text: "ข้อมูลพนักงานราชการ กรอบอัตรากำลัง", icon: "mdi-table-account", to: "/college/gov_em/government_employee" },
      {
        text: "โยกย้าย/สับเปลี่ยน/เกลี่ยอัตรา ระหว่างสถานศึกษา",
        icon: "mdi-swap-horizontal-bold",
        to: "/college/gov_em/transfer_requests",
        hint: "ทำรายการโดยตรงกับสถานศึกษาอีกแห่ง ไม่ต้องผ่านส่วนกลาง"
      },
      { text: "เงื่อนไขสาขา ตำแหน่งว่างพนักงานราชการ", icon: "mdi-source-branch", to: "/college/conditions_branch_govem" },
      { text: "คำร้องขอย้ายพนักงานราชการ (ให้ความเห็น)", icon: "mdi-account-arrow-right", to: "/college/transference_personnel_govem" },
      { text: "รับรายงานตัวพนักงานราชการ (ย้าย)", icon: "mdi-account-check", to: "/college/conditons_transfer_success_gov" },
      { text: "รับรายงานตัว กรณีย้าย (ข้อมูลเดิม)", icon: "mdi-account-arrow-left", to: "/college/gov_em/receive_govem" },
      { text: "รายงานผลการประเมินการปฏิบัติงาน", icon: "mdi-star-check", to: "/college/gov_em/assessment_govem" },
      { text: "การคำนวณค่าตอบแทนพนักงานราชการ", icon: "mdi-calculator", to: "/college/gov_em/cal_compensation" },
      { text: "ประวัติพนักงานราชการพ้นสภาพ (ลาออก)", icon: "mdi-account-off", to: "/college/gov_em/ResignHistoryPage" }
    ]
  }
};

export const GROUP_ORDER = ["general", "personnel", "manpower", "move_teach", "move_manage", "sedirector", "assist", "govem"];

// สถานะภารกิจ (ตรงกับ status ที่ backend ส่งมา)
export const STATUS_META = {
  done: { text: "ทำรายการแล้ว", color: "success", icon: "mdi-check-circle" },
  none: { text: "ไม่มีรายการ", color: "blue-grey lighten-1", icon: "mdi-check-circle-outline" },
  partial: { text: "กำลังดำเนินการ", color: "amber darken-2", icon: "mdi-progress-clock" },
  todo: { text: "ยังไม่ดำเนินการ", color: "red darken-1", icon: "mdi-alert-circle" },
  upcoming: { text: "กำลังจะเปิด", color: "indigo lighten-1", icon: "mdi-calendar-clock" }
};
